export default __webpack_public_path__ + "static/media/androidstudio.6a36f152.png";